import React from "react";
import BuildIcon from "@mui/icons-material/Build";
import Button from "components/Button";
import {
  ButtonWrapper,
  FallbackContainer,
  IconStyle,
  ReturnButton,
  TextContainer,
} from "./style";

export function fallbackRender() {
  function handleRedirect() {
    window.location.href = "/";
  }

  return (
    <div style={{ ...FallbackContainer, ...{ textAlign: "center" } }}>
      <p>
        <span style={{ ...TextContainer, ...{ position: "relative" } }}>
          <BuildIcon style={{ ...IconStyle, ...{ position: "absolute" } }} />
          Something went wrong. We are working on it and we'll get it fixed as
          soon as we can.
        </span>
      </p>
      <p>
        <span style={ButtonWrapper}>
          <button style={ReturnButton} onClick={handleRedirect}>
            Return Home
          </button>
        </span>
      </p>
    </div>
  );
}
